import { Form } from 'react-bootstrap';
import { UseControllerProps, useController } from 'react-hook-form';

export type TimeRangeControlProps = UseControllerProps<any> & {
  placeholder?: string;
  startFieldName: string;
  endFieldName: string;
  minHour?: number;
  maxHour?: number;
  stepMinute?: number;
  disabled?: boolean;
};

function pad2(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

function buildOptions(minHour: number, maxHour: number, stepMinute: number): { label: string; value: string }[] {
  const options: { label: string; value: string }[] = [];
  for (let hour = minHour; hour <= maxHour; hour += 1) {
    const minutes: number[] = [];
    if (hour === maxHour) {
      minutes.push(0);
    } else {
      for (let minute = 0; minute < 60; minute += stepMinute) {
        minutes.push(minute);
      }
    }
    minutes.forEach((minute) => {
      options.push({
        label: `${pad2(hour)} : ${pad2(minute)}`,
        value: `${pad2(hour)}:${pad2(minute)}`,
      });
    });
  }
  return options;
}

function TimeRangeControl(props: TimeRangeControlProps) {
  const {
    placeholder = '指定なし',
    startFieldName,
    endFieldName,
    minHour = 0,
    maxHour = 29,
    stepMinute = 30,
    disabled,
  } = props;
  const {
    field: { value, onChange },
  } = useController(props);

  const options = buildOptions(minHour, maxHour, stepMinute);

  const startValue: string = value?.[startFieldName] ?? '';
  const endValue: string = value?.[endFieldName] ?? '';

  function handleChange(fieldName: string, newValue: string) {
    onChange({
      ...value,
      [fieldName]: newValue === '' ? null : newValue,
    });
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Form.Select
        className="text-center"
        value={startValue}
        onChange={(e) => handleChange(startFieldName, e.target.value)}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        <option value="Open">Open</option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            // disabled={endValue !== '' && endValue !== 'Close' && option.value >= endValue}
          >
            {option.label}
          </option>
        ))}
        {/* <option value="Close">Close</option> */}
      </Form.Select>
      <span>~</span>
      <Form.Select
        className="text-center"
        value={endValue}
        onChange={(e) => handleChange(endFieldName, e.target.value)}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {/* <option value="Open">Open</option> */}
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            // disabled={startValue !== '' && startValue !== 'Open' && option.value <= startValue}
          >
            {option.label}
          </option>
        ))}
        <option value="Close">Close</option>
      </Form.Select>
    </div>
  );
}

export default TimeRangeControl;
